import { Helpers } from '../../helpers';
import { IFuelGasContractStatus } from '../../interfaces/ifuel-gas-contract-status';
import { TankBattery } from '../tank-battery';

export class FuelGasContractStatusBase {
  FuelGasContractStatusId: number;
  Description: string | null;
  Abbreviation: string | null;
  SortOrder: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  TankBatteries_FuelGasContractStatus?: Array<TankBattery> | null;

  constructor(item?: IFuelGasContractStatus) {
    if (item) {

      this.FuelGasContractStatusId = item.FuelGasContractStatusId;
      this.Description = item.Description;
      this.Abbreviation = item.Abbreviation;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.TankBatteries_FuelGasContractStatus = Helpers.createClassArray(TankBattery, item.TankBatteries_FuelGasContractStatus);
    }
  }
}